import { Controller } from '@hotwired/stimulus'
import { loadGoogleMaps } from './maps_loader'

export default class extends Controller {
  static targets = ['modal', 'map']
  static values = {
    lat: Number,
    lng: Number,
    apiKey: String,
  }

  // コンポーネントSCSSは viewcomponent::<identifier>:: を自動前置される。
  // JSが付与する状態クラスもスコープ済み名にする必要があるため css_root_selector を data 経由で受け取る。
  className () {
    return this.element.dataset.classname
  }

  // モーダルが開いたままTurbo遷移すると overflow:hidden がリークし次ページでスクロール不能になるため、
  // disconnect で必ずbody/htmlのoverflowを復元する
  disconnect () {
    document.body.style.removeProperty('overflow')
    document.documentElement.style.removeProperty('overflow')
  }

  open () {
    this.savedScrollY = window.scrollY
    this.modalTarget.classList.add(`${this.className()}::is-open`)
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'

    // APIキーが無い環境（test等）では地図ロードをスキップ（外部通信を発生させない）
    if (!this.apiKeyValue) return

    // 座標欠損時は地図を描画しない（Number型のデフォルト0で(0,0)地図を無言表示するのを防ぐ）
    if (!this.latValue || !this.lngValue) return

    loadGoogleMaps(this.apiKeyValue)
      .then(() => this.initMap())
      .catch((error) => {
        if (typeof Sentry !== 'undefined') {
          Sentry.captureException(error, { tags: { component: 'facility-map-modal', operation: 'load-google-maps' } })
        }
        console.error('[MapModal] Google Maps の読み込みに失敗しました:', error)
        this.mapTarget.innerHTML =
          '<p style="padding:16px;text-align:center;color:#666;">地図の読み込みに失敗しました。<br>通信環境をご確認のうえ、再度お試しください。</p>'
      })
  }

  close () {
    this.modalTarget.classList.remove(`${this.className()}::is-open`)
    document.body.style.removeProperty('overflow')
    document.documentElement.style.removeProperty('overflow')
    window.scrollTo(0, this.savedScrollY || 0)
  }

  initMap () {
    if (this.map) return // 二重初期化防止

    const position = { lat: this.latValue, lng: this.lngValue }
    this.map = new google.maps.Map(this.mapTarget, {
      center: position,
      zoom: 16,
      gestureHandling: 'greedy', // 一本指操作
      clickableIcons: false, // 他POIの情報ウィンドウを開かせない
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
    })

    // 赤い標準ピンのみ表示（施設名ポップアップは表示しない）
    this.marker = new google.maps.Marker({
      position,
      map: this.map,
    })
  }
}
